// The organization's butterfly mark, as the app shell's brand glyph (owner,
// 2026-09-01: the receipt icon it replaced sat immediately left of a tab strip
// whose first tab — Invoices — carries that SAME receipt icon, so the header
// opened with the same picture twice; the outlined-wordmark treatment tried
// next did not land either).
//
// INLINE, NOT AN <img>. The header is above the fold on every screen, so the
// mark should not cost a second round trip or paint after the words beside it;
// and inlining lets it size from CSS like any other glyph. `app/public/
// butterfly.svg` is the same artwork as a file, for the favicon, which cannot
// be inlined — the two are one asset in two forms and must be replaced
// together.
//
// The colours are the brand's own, not theme tokens: this is a logo, and a logo
// that changes colour with the UI is not the logo. It is safe today because the
// app is light-only (`createLightTheme` in `lib/theme.ts`); a dark theme would
// need the near-black stroke (#231f20) reconsidered, not re-tinted.
//
// Decorative: the wordmark beside it already names the app, so a screen reader
// announcing "Accounts Payable" twice would be worse than silence.

import { BRAND_FLIP, BRAND_PATHS, BRAND_VIEWBOX } from '../lib/brand'

export function BrandMark({ className, size = 26 }: { className?: string; size?: number }) {
  return (
    <svg
      className={className}
      viewBox={`0 0 ${BRAND_VIEWBOX} ${BRAND_VIEWBOX}`}
      width={size}
      height={size}
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      {BRAND_PATHS.map((path) => (
        <path key={path.d.slice(0, 24)} transform={BRAND_FLIP} fill={path.fill} d={path.d} />
      ))}
    </svg>
  )
}
